<template>
    <div class="checkpoint-info">
        
        <h2 class='checkpoint-title row'> 
            <!-- <i class="vtl vtl-trecho  fa-2x"></i>  -->
            <span class='checkpoint-name col'>{{ currentRaceName }} - {{ name }} </span>
            <div class="navegationTrechos" style="text-align:right;width:100%;">
                    <a class='prev' @click="prev()"> <i class='fa fa-arrow-left'></i> </a>
                    <a class='next' @click="next()"> <i class='fa fa-arrow-right'></i> </a>
            </div>
        </h2>

      
        <!-- <hr/> -->
        
            <div class="stats row mb2">
                    <div v-if="distanceUp != NaN " class=' f3 col'>  <i class='vtl vtl-distance '></i> <b class="">{{ distance }}</b> <small class="">kms </small>
                        <div class="ml3">
                        <small class=" f6"> 
                           
                              <span v-if="distanceUp > distanceDown" class="up-dist" >    <i  class='fa fa-long-arrow-up'></i> </span>
                              <span v-else class="down-dist "> <i  class='fa fa-long-arrow-down'></i>  </span>
                              
                                    {{Math.abs((distanceUp-distanceDown).toFixed(2))}} kms
                          
                                    <!-- <span class="up-dist" :class="{'predominant':stats.dist_up>stats.dist_down}"> <i class='fa fa-long-arrow-up'></i> {{distanceUp}}</span>  -->
                                    <!-- <span class="down-dist" :class="{'predominant':stats.dist_up<stats.dist_down}"> <i class='fa fa-long-arrow-down'></i> {{distanceDown}} </span>  -->
                                    <!-- <span class="avr-angle" :style="{display:'inline-block',transform:'rotate('+-stats.avg_angle+'deg)'}"> <i class='fa fa-arrow-right'></i>  </span> -->
                        </small>
                        </div>
                    </div>
                
                    <div class=' f6 mt1 mb2 col tr'>
                        <i class='fa fa-clock-o '></i> <b> {{trecho.properties.abertura}} | {{trecho.properties.fechamento}} </b>
                    </div>
            </div>
            <div class="info">
            <!-- {{ stats }} -->

            <!-- TODO - VOLTAR PARA MOSTRAR INFOS DO TRECHO -->
            <!-- <div  class='text descripition mt3 f6' v-html="'EM BREVE DESCRIÇÃO DO TRECHO'"> </div> -->
            <div  class='text descripition mt3 f6' v-html="info"></div>

            <div style="width:100%;height:200px;">

                    <elevation-plot :startedDistance="trecho.properties.km" :geoJSON="trecho" :duration="3" :steps="50" :delay="0.8" >
                    </elevation-plot>
            </div>


        </div>
    </div>
</template>


<script>

import marked from 'marked'
export default {

    props:['trecho'],

    computed:{
        currentRaceName:function(){
                return this.$store.getters.currentRaceName;
            },
        checkpoints:function(){
            return this.$store.getters.checkpoints;
        },
        lang:function(){
            return this.$store.getters.currentLang;
        },
        distance:function(){
             return _.get(this.trecho,'properties.distance',0).toFixed(2)
        },
        distanceInMeter:function(){
             return _.get(this.trecho,'properties.distance',0)
        },
        name:function(){
            var prop = "name"
            if(this.lang=="en") prop +="_en";
            if(_.get(this.trecho,'properties.tipotrecho','') === 'percurso'){
                return "Inicio do percurso"
            }
            return  _.get(this.trecho,'properties.'+prop) 
        },
        info:function(){
            var prop = "description"
            if(this.lang=="en") prop +="_en";
            var html = _.get(this.trecho,'properties.'+prop,'')
            return this.parseMarkedown(html)
        },
        stats:function(){
            return _.courseStats(this.trecho)
        },
        distanceUp:function(){
            return (this.stats.dist_up/1000).toFixed(2)
        },
        distanceDown:function(){
            return (this.stats.dist_down/1000).toFixed(2)
        },

    },

    methods:{
        parseMarkedown:function(text){
            return marked(text,{breaks:true})
        },
          prev:function(){
                var actualIndex = _.get(this.$route,'params.id',0);
                actualIndex--
                if( actualIndex < 0 ){
                    actualIndex = this.checkpoints.length-1
                }
                this.$router.push( {params: { id: actualIndex }} )
            },

            next:function(){
                var actualIndex = _.get(this.$route,'params.id',0);
                actualIndex++
                if( actualIndex > this.checkpoints.length-1 ){
                    actualIndex = 0
                }
                this.$router.push( {params: { id: actualIndex }} )
            },
    }
}

</script>

<style lang="stylus">
    @import "./../css/variaveis"
    
    .checkpoint-info{

        h2{ 
            // font-size:2.9rem;
            line-height 1.2;
            font-weight bolder;
            border-bottom: 1px solid rgba(black,0.2);
            padding-bottom:0.5rem;
            margin-bottom:0 !important;
            color:#8bd4cb !important;
            .checkpoint-name{
                 font-size:1.9rem;
            }
        }

        .info{
           
        }
        .stats{
            opacity 0.5;
            color:black;
            margin-top:0;
        }

        .descripition p{
            margin-left:1em;    
            font-size:0.9em !important;
            br{
                display:block;
                margin-top:0.45em;
                content:"",
            }
            b,strong{
                color:rgba(white,0.8);
            }
        }
    }

    .up-dist i{
        color:red;
    }

    .down-dist i{
        color:#63E3FF;
    }

</style>
